import React from 'react'
import { styled } from '@mui/material/styles'
import T from 'prop-types'
import { Box, MenuItem, Stack } from '@mui/material'
import WatchLaterIcon from '@mui/icons-material/WatchLater'
import { useTranslation } from 'react-i18next'

import InputLabel from './InputLabel'
import SelectScrollable from './SelectScrollable'

const StyledSelect = styled(SelectScrollable)(({ theme }) => ({
  '&::before, &::after': {
    border: 'none',
  },
  '&:hover:not(.Mui-disabled):before': {
    border: 'none',
  },
}))

export default function SessionsSelect({
  label,
  value,
  sessions = [],
  readOnly,
  renderIcon,
  handleSessionChange = () => {},
}) {
  const { t } = useTranslation()

  return (
    <Stack
      direction="row"
      alignItems="center"
      data-testid="session-list-component"
    >
      {renderIcon ? (
        renderIcon({ color: 'primary' })
      ) : (
        <WatchLaterIcon color="primary" />
      )}
      <Box pr={1} />
      <Stack>
        <InputLabel
          label={label || t('common.form.sessionId')}
          inputId="page-title-session-select"
          sx={{ pr: 0.5 }}
        />
        <StyledSelect
          data-testid="page-title-session-select"
          id="page-title-session-select"
          variant="standard"
          size="small"
          value={value || ''}
          readOnly={readOnly}
          onChange={handleSessionChange}
        >
          {sessions.map((s) => {
            return (
              <MenuItem key={s.sessionId} value={s.sessionId}>
                {s.sessionId}
              </MenuItem>
            )
          })}
        </StyledSelect>
      </Stack>
    </Stack>
  )
}

SessionsSelect.propTypes = {
  label: T.string,
  value: T.string,
  sessions: T.array,
  readOnly: T.bool,
  renderIcon: T.func,
  handleSessionChange: T.func,
}
